// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://iaddwpyaxyaayklwogux.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlhZGR3cHlheHlhYXlrbHdvZ3V4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzc3NDI2MjQsImV4cCI6MjA1MzMxODYyNH0.j-ByB9b7jNPhT43VZ09nwilSz3QJ7LG0ltoD8Z_s7yc";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);